import { render, staticRenderFns } from "./CreateAccount.vue?vue&type=template&id=2f67ebef&scoped=true"
import script from "./CreateAccount.vue?vue&type=script&lang=js"
export * from "./CreateAccount.vue?vue&type=script&lang=js"
import style0 from "./CreateAccount.vue?vue&type=style&index=0&id=2f67ebef&prod&lang=scss"
import style1 from "./CreateAccount.vue?vue&type=style&index=1&id=2f67ebef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f67ebef",
  null
  
)

export default component.exports